"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Table_less_1 = __importDefault(require("./Table.less"));
var Cell_1 = __importDefault(require("./Cell/Cell"));
var WEEK_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
var Table = function (_a) {
    var items = _a.items, selected = _a.selected, monthInfo = _a.monthInfo, onChange = _a.onChange;
    var t = (0, react_i18next_1.useTranslation)().t;
    var cellsOffset = (0, react_1.useMemo)(function () {
        return Array.from(Array(monthInfo.firstWeekday).keys());
    }, [monthInfo]);
    return (react_1.default.createElement("div", { className: Table_less_1.default['table'] },
        react_1.default.createElement("div", { className: Table_less_1.default['week'] }, WEEK_DAYS.map(function (day) { return (react_1.default.createElement("div", { className: Table_less_1.default['day'], key: day },
            react_1.default.createElement("span", { className: Table_less_1.default['long'] }, t(day)),
            react_1.default.createElement("span", { className: Table_less_1.default['short'] }, t(day).slice(0, 3)))); })),
        react_1.default.createElement("div", { className: Table_less_1.default['grid'] },
            cellsOffset.map(function (day) { return (react_1.default.createElement("span", { key: day })); }),
            items.map(function (item) { return (react_1.default.createElement(Cell_1.default, __assign({ key: item.date.day }, item, { selected: selected, monthInfo: monthInfo, onClick: onChange }))); }))));
};
exports.default = Table;
